import {EventBus} from '@mintdata-wsp/common/bus/EventBus';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import bind from 'bind-decorator';
import {action} from 'mobx';

export class ReconnectionController
{
    public init()
    {
        const {multiplayer} = controllers.ui;

        EventBus.listen(multiplayer, {
            onConnectionLost: this.onConnectionLost,
            onConnectionRestored: this.onConnectionRestored,
            onDisconnected: this.onDisconnected
        });
    }

    @bind
    private onConnectionLost()
    {
        this._showReconnectionToast();
    }

    @bind
    private onConnectionRestored()
    {
        this._hideReconnectionToast();
    }

    @bind
    private onDisconnected()
    {
        this._hideReconnectionToast();
    }

    @action.bound
    private _showReconnectionToast():void
    {
        rootState.net.isSocketReconnecting = true;
        controllers.ui.toasts.showSocketReconnection(rootState.net);
    }

    @action.bound
    private _hideReconnectionToast():void
    {
        controllers.ui.toasts.hideSocketReconnection();
    }
}
